export const MODE_NAME = "split_line_string";

// This mode uses the `mapbox-gl-draw-passing-mode` mode to draw the splitting lineString.
export const PASSING_MODE_NAME = `${MODE_NAME}_passing_draw_line_string`;

// When a LineString feature is selected to be split, it gets highlighted.
// This is the name of the property indicating the highlight.
export const HIGHLIGHT_PROPERTY_NAME = `${MODE_NAME}_highlight`;

export const defaultOptions = {
  highlightColor: "#2196F3",
};
